import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { useTheme } from '@mui/material/styles'
import type { CalendarView } from '../../typings'
import { TOUCH_TARGET_PX } from '../touch'

type Props = {
  view: CalendarView
  onToday: () => void
  onPrev: () => void
  onNext: () => void
}

// Per-view accessible names — a static "Previous" is wrong in two of three views.
const UNIT_LABEL: Record<CalendarView, string> = {
  month: 'month',
  week: 'week',
  day: 'day',
}

// 44x44 at every size (Apple HIG + story AC; fixes prototype's 29x29).
const TOUCH_TARGET = TOUCH_TARGET_PX

export function NavButtons({ view, onToday, onPrev, onNext }: Props) {
  const theme = useTheme()
  const unit = UNIT_LABEL[view]

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={onToday}
        sx={{
          minHeight: TOUCH_TARGET,
          textTransform: 'none',
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
        }}
      >
        Today
      </Button>
      <IconButton
        onClick={onPrev}
        aria-label={`Previous ${unit}`}
        sx={{ width: TOUCH_TARGET, height: TOUCH_TARGET }}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        onClick={onNext}
        aria-label={`Next ${unit}`}
        sx={{ width: TOUCH_TARGET, height: TOUCH_TARGET }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  )
}
